(() => {

  const popup = document.getElementById("CustomPopup");

  if (!popup) return;

  const overlay = popup.querySelector(".cp-overlay");
  const closeBtn = popup.querySelector(".cp-close");

  const delay = Number(popup.dataset.delay || 2) * 1000;
  const frequency = Number(popup.dataset.frequency || 1);

  const STORAGE_KEY = "custom-popup-last-close";

  function shouldShowPopup() {

    // Every visit
    if (frequency === 0) {
      return true;
    }

    const lastClose = localStorage.getItem(STORAGE_KEY);

    if (!lastClose) {
      return true;
    }

    const diff =
      Date.now() - new Date(lastClose).getTime();

    const days =
      diff / (1000 * 60 * 60 * 24);

    return days >= frequency;

  }

  function saveCloseTime() {

    localStorage.setItem(
      STORAGE_KEY,
      new Date().toISOString()
    );

  }

  function openPopup() {

    popup.classList.add("active");

    document.body.style.overflow = "hidden";

  }

  function closePopup() {

    popup.classList.remove("active");

    document.body.style.overflow = "";

    if (frequency !== 0) {
      saveCloseTime();
    }

  }

  window.addEventListener("load", () => {

    console.log("Popup Frequency:", frequency);
    console.log("Should Show:", shouldShowPopup());

    if (!shouldShowPopup()) return;

    setTimeout(openPopup, delay);

  });

  closeBtn?.addEventListener("click", closePopup);

  overlay?.addEventListener("click", closePopup);

  document.addEventListener("keydown", (e) => {

    if (e.key === "Escape") {

      closePopup();

    }

  });

})();